// extracted by mini-css-extract-plugin
export default {"container":"badges_container__Ju9iw","titleWrap":"badges_titleWrap__bAZZ3","badgesWrap":"badges_badgesWrap__O5Gxw","overlay":"badges_overlay__Uk28f"};